import { useVideoClassificationTip } from './useVideoClassificationTip';
import { VideoClassificationTipProps } from './types';
import styles from './VideoClassificationTip.module.css';

/**
 * 動画分類情報を表示するタグコンポーネント
 * 診療科や関連情報を検索可能なタグとして表示します
 */
const VideoClassificationTip = ({ video }: VideoClassificationTipProps) => {
  const { tipParts, handleTagClick } = useVideoClassificationTip({ video });

  // tipPartsが空の場合は何も表示しない
  if (tipParts.length === 0) return null;

  return (
    <div 
      className={styles['video-classification-tip__container']}
      data-testid="video-classification-tip__container"
    >
      {tipParts.map((part, index) => (
        <button
          key={index}
          className={styles['video-classification-tip__tag']}
          onClick={() => handleTagClick(part.searchQuery)}
          title={`${part.searchQuery.split(':')[0]}「${part.text}」で検索`}
          data-testid={`video-classification-tip__tag-${index}`}
        >
          {part.text}
        </button>
      ))}
    </div>
  );
};

export default VideoClassificationTip; 